import { render, staticRenderFns } from "./AddImageWidget.vue?vue&type=template&id=6e7c8611"
import script from "./AddImageWidget.vue?vue&type=script&lang=js"
export * from "./AddImageWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports